import { render, staticRenderFns } from "./Studio.vue?vue&type=template&id=96a4dc0e&scoped=true&"
import script from "./Studio.vue?vue&type=script&lang=ts&"
export * from "./Studio.vue?vue&type=script&lang=ts&"
import style0 from "./Studio.vue?vue&type=style&index=0&id=96a4dc0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a4dc0e",
  null
  
)

export default component.exports